import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import PublicPage from "@/pages/PublicPage";
import AlumniPage from "@/pages/AlumniPage";
import LoginPage from "@/pages/LoginPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import PjDashboard from "@/pages/PjDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

function RequireAuth({ roles }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/infaq/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/infaq" replace />;
  return <Outlet />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Navigate to="/infaq" replace />} />
          <Route path="/infaq" element={<PublicPage />} />
          <Route path="/infaq/alumni" element={<AlumniPage />} />
          <Route path="/infaq/login" element={<LoginPage />} />

          <Route element={<RequireAuth />}>
            <Route path="/infaq/ganti-sandi" element={<ChangePasswordPage />} />
          </Route>

          <Route element={<RequireAuth roles={["pj"]} />}>
            <Route path="/infaq/pj-kelas" element={<PjDashboard />} />
          </Route>

          <Route element={<RequireAuth roles={["admin"]} />}>
            <Route path="/infaq/bendahara" element={<AdminDashboard />} />
          </Route>

          <Route path="*" element={<Navigate to="/infaq" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
